// extracted by mini-css-extract-plugin
export default {"container":"RailDual_container__PQgvr"};